<template>
    <div id="app" class="flex antialiased text-xs text-pastel-black justify-center h-full bg-gray-200">
        <div class="mt-20 w-10/12 md:w-auto">
            <div class="md:flex bg-white rounded-lg p-10 border">
                <div class="rounded-full h-24 w-24 md:h-24 md:w-24 flex items-center justify-center bg-gray-200 mx-auto md:mx-0 md:mr-6">
                    <!--<font-awesome-icon icon="leaf" class="text-4xl md:text-5xl text-white" :spin="false" />-->
                    <img alt="NILU � Norsk institutt for luftforskning" title="NILU � Norsk institutt for luftforskning" data-src="nilulogo.svg" class="nilu-logo lazyloaded" src="nilulogo.svg">

                </div>

                <div v-show="!setNewPassword" class="text-center md:text-left">
                    <!-- Username -->
                    <div class="mt-2 md:mt-0 flex justify-center">
                        <l-input v-model="username" type="text" placeholder="E-post" @keyup.enter.native="handleSubmit">
                            <template slot="prefix">
                                <font-awesome-icon icon="user" class="text-xl text-gray-500" />
                            </template>
                        </l-input>
                    </div>
                    <!-- Password -->
                    <div class="mt-2 md:mt-1 flex justify-center">
                        <l-input v-model="password" type="password" placeholder="Passord" @keyup.enter.native="handleSubmit">
                            <template slot="prefix">
                                <font-awesome-icon icon="key" class="text-xl text-gray-500" />
                            </template>
                        </l-input>
                    </div>
                    <!-- Submit -->
                    <div class="mt-2 md:mt-1 flex justify-center">
                        <l-button type="success" class="w-full flex justify-center" :disabled="disableLogin" @click="handleSubmit">
                            <div class="self-center">
                                <font-awesome-icon v-show="authenticating" icon="spinner" class="text-base text-white" :spin="true" />
                            </div>
                            <div class="ml-2 self-center">Logg inn</div>
                        </l-button>
                    </div>
                    <!-- Error message -->
                    <div class="p-2 flex text-xs justify-center font-bold text-pastel-red-500" v-show="authenticationError">{{ authenticationError }}</div>
                </div>

                <div v-show="setNewPassword" class="text-center md:text-left">
                    <!-- Username -->
                    <div class="mt-2 md:mt-0 flex justify-center">
                        <b class="text-xl">{{ username }}</b>
                    </div>
                    <!-- Password -->


                    <div class="mt-2 md:mt-1 flex justify-center">
                        <l-input v-model="password" type="password" placeholder="Passord" @keyup.enter.native="handleSubmit">
                            <template slot="prefix">
                                <font-awesome-icon icon="key" class="text-xl text-gray-500" />
                            </template>
                        </l-input>
                    </div>
                    <!-- Submit -->
                    <div class="mt-2 md:mt-1 flex justify-center">
                        <l-button type="success" class="w-full flex justify-center" :disabled="password.length < 8" @click="handleSubmit">
                            <div class="self-center">
                                <font-awesome-icon v-show="authenticating" icon="spinner" class="text-base text-white" :spin="true" />
                            </div>
                            <div class="ml-2 self-center">Lagre passord og logg inn</div>
                        </l-button>
                    </div>
                    <!-- Error message -->
                    <div class="pt-2 md:mt-0 flex justify-center">
                        <i class="text-pastel-red-500" v-if="password.length < 8">
                            * Passordet m&aring; ha minst 8 tegn
                        </i>
                    </div>
                    <div class="p-2 flex text-xs justify-center font-bold text-pastel-red-500" v-show="authenticationError">{{ authenticationError }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsersService from "@/helpers/services/users.service.js";
import LError from "@/components/LError";
import { LButton, LInput } from "@/components/forms";
import { LContainer, LContainerTitle, LContainerToolbar } from "@/components/container";

export default {
    name: "Login",
    components: {
        LButton,
        LInput,
        LContainer,
        LContainerTitle,
        LContainerToolbar,
        LError,
    },
    data() {
        return {
            username: "",
            password: "",
            authenticating: false,
            authenticationError: "",
            setNewPassword: false,
            resetpassword: "",
        };
    },
    mounted() {
        //console.log(this.$route);
        //this.handleQuery();
        if (this.$route) {
            if (this.$route.query.user) this.username = this.$route.query.user;
            if (this.$route.query.setNewPwd) this.setNewPassword = true;
            if (this.$route.query.resetpassword) this.resetpassword = this.$route.query.resetpassword;
            if (this.$route.query.email) this.username = this.$route.query.email;
        }
    },
    methods: {
        //handleQuery() {
        //console.log(this.$route);
        //},
        async handleSubmit() {
            if (this.username != "") {
                // && this.password != ""
                if (this.setNewPassword) {
                    this.authenticating = true;
                    await UsersService.setPassword(this.username, this.password, this.resetpassword);
                    this.authenticating = false;
                }

                try {
                    this.authenticationError = "";
                    this.authenticating = true;
                    await UsersService.authenticate(this.username, this.password);
                    this.authenticating = false;
                    if (this.password == "") this.setNewPassword = true;
                    else window.location.href = "/";
                } catch (error) {
                    this.authenticationError = error.message;
                    this.authenticating = false;
                }
            }
        },
    },
    computed: {
        disableLogin() {
            return this.authenticating || this.username == ""; //|| this.password == ""
        },
    },
};
</script>


<style lang="postcss">
@import "../../assets/styles/tailwind.postcss";

html,
body {
    height: 100%;
}

body {
    @apply h-full bg-gray-100;
    font-family: "Rubik", arial;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
    outline: none;
}

.btn-disabled {
    @apply bg-bluegray-300;
    pointer-events: none;
}

    .nilu-logo {
        /*display: block;*/
        /*width: 65px;*/
        height: 128px;
        max-width: unset;
    }
</style>
